import { render, staticRenderFns } from "./table-views.vue?vue&type=template&id=0996c0e0&scoped=true"
import script from "./table-views.vue?vue&type=script&lang=js"
export * from "./table-views.vue?vue&type=script&lang=js"
import style0 from "./table-views.vue?vue&type=style&index=0&id=0996c0e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0996c0e0",
  null
  
)

export default component.exports